/**
 * 短信管理组件（合并配置和记录）
 * 功能：短信平台配置 + 验证码发送记录
 */
import React, { useState } from 'react'
import { Cog6ToothIcon, ClockIcon } from '@heroicons/react/24/outline'
import SmsConfigManagement from './SmsConfigManagement'
import SmsLogsManagement from './SmsLogsManagement'

type TabType = 'config' | 'logs'

export default function SmsManagement() {
    const [activeTab, setActiveTab] = useState<TabType>('config')

    return (
        <div>
            {/* Tab 切换 */}
            <div className="flex border-b border-gray-200 mb-0 bg-white px-6 pt-4">
                <button
                    onClick={() => setActiveTab('config')}
                    className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'config'
                            ? 'border-cyan-600 text-cyan-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'
                        }`}
                >
                    <Cog6ToothIcon className="w-5 h-5 inline mr-2" />
                    平台配置
                </button>
                <button
                    onClick={() => setActiveTab('logs')}
                    className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'logs'
                            ? 'border-cyan-600 text-cyan-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'
                        }`}
                >
                    <ClockIcon className="w-5 h-5 inline mr-2" />
                    发送记录
                </button>
            </div>

            {/* Tab 内容 */}
            {activeTab === 'config' && <SmsConfigManagement />}
            {activeTab === 'logs' && <SmsLogsManagement />}
        </div>
    )
}
